import { FC } from 'react';
import { sortBy } from 'lodash';
import CommonButton from 'components/CommonButton/CommonButton';
import DefaultModal from 'components/Modals/DefaultModal';
import { PractitionerException } from 'interfaces/practitionerException';
import { datetimeFormat } from 'utils/datetime';
import moment from 'moment';

interface OverrideOperatoryProps {
  onConfirm: () => void;
  onCancel: () => void;
  exceptionDates: PractitionerException[];
}

const OverrideOperatory: FC<OverrideOperatoryProps> = ({
  onCancel,
  onConfirm,
  exceptionDates,
}) => {
  const renderOperatories = (exceptionDate: PractitionerException) => {
    const operatories = exceptionDate.operatories;

    return sortBy(operatories.map((item) => item.name)).join(', ');
  };

  const isYearInTheFuture = (dateString: string) => {
    return moment().isBefore(moment(dateString, 'YYYY-MM-DD'), 'years');
  };

  const displayHour = (exceptionDate: PractitionerException) => {
    if (typeof exceptionDate.workingHour !== 'string') {
      const startDate = datetimeFormat({
        dateString: exceptionDate.workingHour[0].start!,
        format: 'HH:mm:ss',
        pattern: 'hh:mmA',
      });
      const endDate = datetimeFormat({
        dateString: exceptionDate.workingHour[0].end!,
        format: 'HH:mm:ss',
        pattern: 'hh:mmA',
      });

      return `${startDate} - ${endDate}`;
    }
  };

  return (
    <DefaultModal>
      <div className="w-63 max-h-[50.2rem] pt-2 pb-2.9 px-2 text-darkest-grey text-14 leading-[2.1rem]">
        <h3 className="font-bold text-20 leading-[3rem]">
          Review these custom days?
        </h3>
        <span className="mt-0.8">
          By proceeding, the operatories for the custom days listed below will
          be affected
        </span>
        <div
          className={`border-b-[2px] border-grey pb-0.9 mt-2.4 grid grid-cols-[1fr_1fr_1fr] items-center`}
        >
          <span className="font-bold">Date</span>
          <span className="font-bold">Hours</span>
          <span className="font-bold">Operatories</span>
        </div>
        <div className="max-h-[28rem] scrollbar overflow-auto text-darkest-grey ">
          {sortBy(exceptionDates, 'date').map((option, index) => (
            <div
              key={option.id}
              className={`grid min-h-[4rem] py-0.6 items-center border-b border-b-light-grey grid-cols-[1fr_1fr_1fr] ${
                index % 2 ? 'bg-lightest-grey' : 'bg-white'
              } `}
            >
              <label htmlFor={option.id}>
                {datetimeFormat({
                  dateString: option.date,
                  format: 'YYYY-MM-DD',
                  pattern: `ddd, MMM DD${
                    isYearInTheFuture(option.date) ? ', YYYY' : ''
                  }`,
                })}
              </label>
              <span>{displayHour(option)}</span>
              <span>{renderOperatories(option)}</span>
            </div>
          ))}
        </div>

        <div className="flex justify-end gap-x-1.6 mt-2.5">
          <CommonButton variant="secondary" onClick={onCancel}>
            Cancel
          </CommonButton>
          <CommonButton onClick={onConfirm}>Confirm</CommonButton>
        </div>
      </div>
    </DefaultModal>
  );
};

export default OverrideOperatory;
